export default __webpack_public_path__ + "static/media/screen1.be42ca5a.png";